<db-dialog-wrapper [dialog]="this" [width]="'700px'" [height]="'294px'" [canClose]="true" [hasCloseButton]="true"
                   [fullScreen]="isMobile">
  <div class="db-switch-annual-dialog">
    <div class="db-notification-dialog__header">Confirm billing cycle change</div>
    <div class="db-notification-dialog__message">
      <p>Please confirm the change from a monthly billing cycle to annual.<br> <br>On {{userSubscription?.nextBillingDate | dbDate : 'dd MMM, y' : false}} you will be charged by an annual payment of
        ${{annualPrice}},<br/> when your current monthly plan expires. This amount will be decreased if you<br/>have existing promo codes.</p>
    </div>
    <div class="db-notification-dialog__buttons-wrap">
      <button class="ds-btn-black ds-btn-m" [ngClass]="{'ds-btn-disabled': loading}"
              [disabled]="loading" (click)="confirm()">
        <span *ngIf="!loading">Confirm</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </div>
</db-dialog-wrapper>
